import React, { Component } from "react";
import Api from "../../../../Services/Api";
import API from "../../../../Services/Api";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";

import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { checkResponseError } from "../../../../Services/Utils";
import SimpleSearch from "../../../../modules/SimpleSearch";
import EmployeeSearchForm from "./searchEmployee";
import DDLParamValue from "../../../../modules/commons/DDLParamValue";
import FormEditRole from "../role/formEditRole";
import NormalInput from "../../../../modules/NormalInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import Button from "../../../../modules/commons/Button";

const CryptoJS = require("crypto-js");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class FormSamsat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
        ? props.data
        : {
            userId: null,
            companyGroupId: null,
            companyId: null,
            categoryId: null,
            username: null,
            password: null,
            email: null,
            status: "Active",
            emplId: null,
            name: "",
            action: "NEW",
            kecamatan: null,
            kota: null,
            provinsi: null,
            alamat: null,
            ahassdealercode: null,
            dealercode: null,
            image: null,
            dealername: null,
            description: null,
          },
      name: "",
      detailVisible: false,
      disableName: false,
      category: null,
      employeeSearchFormVisible: false,
      createVisible: false,
      loadSave: false,
      savePopUpVisible: false,
      deletePopUpVisible: false,
      companyData: [],
      dataRole: [],
      dataTable: [],
      countDataRole: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",

      confirmPassVisible: false,
      PassVisible: false,

      maindealername: [
        { label: "Daya" },
        { label: "Wahana" },
        { label: "Jopras" },
      ],

      provinsi: [
        { label: "Jawa Barat" },
        { label: "Jawa Tengah" },
        { label: "Jawa Timur" },
      ],

      kota: [{ label: "Semarang" }, { label: "Solo" }, { label: "Jakarta" }],

      kecamatan: [
        { label: "Bendungan Hilir" },
        { label: "Jombang" },
        { label: "Kuninngan" },
      ],
    };
  }

  showPassword = (type) => {
    switch (type) {
      case "pass":
        this.setState({ PassVisible: !this.state.PassVisible });
        break;
      case "confirm":
        this.setState({ confirmPassVisible: !this.state.confirmPassVisible });
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    this.getCompanyDdl();
    if (this.props.type !== "create") {
      this.setDataValue(this.state.data);
      this.getRole(this.state.table_page, this.state.table_limit);
      // console.log(JSON.stringify(this.state.data, null, 2))
    }
  }

  setDataValue(data) {
    let dataCompany = {
      value: data.companyId,
      label: data.companyName,
    };

    let dataUserCategory = {
      value: data.categoryId,
      label: data.category,
    };

    this.setState({
      data: {
        ...this.state.data,
        categoryIdSelect: dataUserCategory,
      },
      companyIdSelect: dataCompany,
      name: data.name,
      category: data.category,
      disableName: data.category === "Non Employee & Outsource" ? false : true,
    });
  }

  getCompanyDdl() {
    let payload = {
      companyGroupId: "TAB",
    };
    Api.create("MASTERDATA_EKSAD")
      .postGetCompanyDdl(payload)
      .then((res) => {
        if (res.ok && res.data.status === "S") {
          let array = [];
          res.data.data &&
            res.data.data.map((item) => {
              array.push({
                value: item.companyId,
                label: item.companyName,
              });
            });
          this.setState({
            companyData: array,
          });
        }
      });
  }

  getRole = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      roleName: this.state.table_query,
      userId: this.state.data.userId,
    };
    let res = await API.create("MASTERDATA_EKSAD").postGetUserRole(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        let dataTable =
          res.data.data &&
          res.data.data.listRole.map((value) => {
            const { roleCode, roleName, accessType } = value;
            return [roleCode, roleName, accessType];
          });
        this.setState({
          dataRole: res.data.data && res.data.data.listRole,
          dataTable,
          countDataRole: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  validation(data) {
    if (!this.state.data.username) {
      return alert("Username is mandatory.");
    }
    if (!this.state.data.name) {
      return alert("Name is mandatory.");
    }
    if (!this.state.data.categoryId) {
      return alert("User Category is mandatory.");
    }
    if (this.state.data.categoryId === 3 && this.state.name === "") {
      return alert("Employee is mandatory.");
    }
    if (this.state.data.password !== this.state.data.confirmPassword) {
      return alert("Password dengan Confirm Password is not same.");
    }
    if (this.state.data.categoryId === "3" && !this.state.data.email) {
      return alert("Email is mandatory");
    }

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (this.state.data.email && !pattern.test(this.state.data.email)) {
      return alert("Email is not valid");
    }

    if (this.props.type !== "create") {
      this.isLoad(true);
      this.setState(
        {
          data: {
            ...this.state.data,
            action: "EDIT",
          },
        },
        () => {
          this.onClickSave();
        }
      );
    } else {
      this.onClickSave();
    }
  }

  onClickSave = () => {
    this.state.data.password = CryptoJS.MD5(
      this.state.data.password
    ).toString();

    Api.create("LOCAL_CABANG")
      .postCabang(this.state.data)
      .then((res) => {
        if (res.ok && res.data.status === "S") {
          this.isLoad(false);
          this.props.onClickClose();
          this.props.onClickSave(res);
        } else {
          this.isLoad(false);
          this.props.onClickSave(res);
        }
      });
  };

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  onChangeCombo = (event, name) => {
    let value = event.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;

    switch (menu) {
      case "slide-menu-view":
        this.setState({
          detailVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDetailForm = () => {
    this.setState({ detailVisible: !this.state.detailVisible });
  };

  openSearchEmployee = () => {
    if (
      this.props.type === "create" &&
      this.state.data.categoryId &&
      this.state.disableName
    ) {
      this.setState({
        employeeSearchFormVisible: !this.state.employeeSearchFormVisible,
      });
    }
  };

  handleChooseEmployee = async (response) => {
    console.log("Ini Data Employee : " + JSON.stringify(response, null, 2));
    this.setState({
      data: {
        ...this.state.data,
        name: response.emplName,
        emplId: response.emplId,
      },
      name: response.emplName,
    });
  };

  render() {
    return (
      <div>
        <div className="app-popup app-popup-show">
          <div className="padding-top-20px" />
          <div
            className="popup-content background-white border-radius"
            style={{ width: "50%" }}
          >
            <div className="popup-panel grid grid-2x">
              <div className="col-1">
                <div className="popup-title">{"Detail Samsat"}</div>
              </div>
              <div className="col-2 content-right">
                <button
                  className="btn btn-circle btn-grey"
                  onClick={this.props.onClickClose}
                >
                  <i className="fa fa-lg fa-times" />
                </button>
              </div>
            </div>
            <form
              action="#"
              onSubmit={(e) => {
                e.preventDefault();
                this.validation(this.state.data);
              }}
            >
              <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                <div className="column-1">{this.renderForm()}</div>
                <div className="column-2">
                  {/*<div className="margin-5px">*/}
                  {/*    <div className="txt-site txt-11 txt-main txt-bold">*/}
                  {/*        <h4><span style={{color: 'red'}}>*format file (excel)</span></h4>*/}
                  {/*    </div>*/}
                  {/*</div>*/}
                  {this.renderForm2()}
                </div>
              </div>
              <div className="padding-15px">
                <div className="grid grid-2x">
                  <div className="col-1" />
                  <div className="col-2 content-right">
                    {this.props.type === "edit" ||
                    this.props.type === "create" ? (
                      <button
                        className="btn btn-red"
                        type="submit"
                        disabled={this.state.loadSave}
                      >
                        <span>
                          {!this.state.loadSave ? "SAVE" : "Saving..."}
                        </span>
                      </button>
                    ) : null}

                    <button
                      style={{ marginLeft: "15px" }}
                      className="btn btn-primary"
                      type="button"
                      onClick={this.props.onClickClose.bind(this)}
                    >
                      <span>CLOSE</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  columnRole = [
    "Role Code",
    "Role Name",
    {
      name: "Access Type",
      options: {
        customBodyRender: (val) => {
          return (
            <div
              style={{
                width: "90px",
                backgroundColor: val === "Allowed" ? "#00B9F2" : "red",
                borderRadius: 5,
                justifyContent: "center",
              }}
            >
              <div style={{ marginLeft: "20px", color: "white" }}>{val}</div>
            </div>
          );
        },
      },
    },
    this.props.type !== "view"
      ? {
          name: "Action",
          options: {
            customBodyRender: (val, tableMeta) => {
              return (
                <div style={{ width: "115px" }}>
                  <button
                    className="btnAct"
                    style={{ marginRight: 15, backgroundColor: "transparent" }}
                    onClick={this.opSidePage(
                      "slide-menu-view",
                      tableMeta.rowIndex
                    )}
                  >
                    <i
                      className="fa fa-lw fa-ellipsis-v"
                      style={{
                        backgroundColor: "transparent",
                        color: "#004c97",
                        fontSize: 20,
                      }}
                    />
                  </button>
                </div>
              );
            },
          },
        }
      : "",
  ];

  renderTable() {
    let { countDataRole, table_query } = this.state;
    let tableOptions = {
      ...options,
      serverSide: true,
      count: countDataRole,
      searchText: table_query,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getRole(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getRole(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.getRole(tableState.page, tableState.rowsPerPage);
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            key={countDataRole}
            title={"User Roles"}
            subtitle={"User Role List"}
            data={this.state.dataTable}
            columns={this.columnRole}
            options={tableOptions}
          />
        </MuiThemeProvider>
        {this.state.detailVisible && (
          <FormEditRole
            type={"view"}
            data={this.state.dataRole[this.state.selectedIndex]}
            formUser={true}
            loadSave={this.state.loadSave}
            onClickClose={this.openDetailForm.bind(this)}
          />
        )}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <span>Samsat Code: XXX391709XXX</span>
        <NormalInput
          name="namasamsat"
          label={"Samsat Name:"}
          value={this.state.data.namasamsat}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <div
          style={{
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            marginBottom: "30px",
          }}
        >
          <SimpleTextArea
            name="alamat"
            label={"Alamat"}
            value={this.state.data.alamat}
            onChange={this.onchangeInput}
            // readOnly={this.props.type === "view" || this.props.type === "edit"}
          />
          <button
            className="btn btn-primary"
            type="button"
            onClick={this.props.onClickClose.bind(this)}
          >
            <span>PICK FROM MAP</span>
          </button>
        </div>
        <NormalInput
          name="coordinate"
          label={"Coordinate:"}
          value={this.state.data.coordinate}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <SimpleDDL
          box={"search"}
          label={"Provinsi:"}
          options={this.state.kecamatan}
          onChange={(e) => this.onChangeCombo(e, "kecamatan")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.kecamatan}
        />
        <SimpleDDL
          box={"search"}
          label={"Kecamatan:"}
          options={this.state.kota}
          onChange={(e) => this.onChangeCombo(e, "kota")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.kota}
        />
        <SimpleDDL
          box={"search"}
          label={"Kota:"}
          options={this.state.maindealername}
          onChange={(e) => this.onChangeCombo(e, "maindealername")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.maindealername}
        />
        <SimpleDDL
          box={"search"}
          label={"Kode Pos:"}
          options={this.state.maindealername}
          onChange={(e) => this.onChangeCombo(e, "maindealername")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.maindealername}
        />
      </div>
    );
  }

  renderForm2() {
    return (
      <div>
        <SimpleDDL
          box={"search"}
          label={"Area:"}
          options={this.state.maindealername}
          onChange={(e) => this.onChangeCombo(e, "maindealername")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.maindealername}
        />
        <SimpleDDL
          box={"search"}
          label={"PIC:"}
          options={this.state.kota}
          onChange={(e) => this.onChangeCombo(e, "kota")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.kota}
        />
        <span>No. Mobile: 081829313131</span>
        <SimpleInput
          name="phone"
          label={"Phone:"}
          value={this.state.data.phone}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <NormalInput
          name="email"
          label={"Email"}
          value={this.state.data.email}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
      </div>
    );
  }
}

export default FormSamsat;
